import { Button, Col, Row } from 'antd';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API } from '../../common/Constants';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';
import { SendOutlined } from '@mui/icons-material';

const InvoiceGenerate = ({ pdfurl }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const LoanStateData = location.state;
    const applicationId = LoanStateData?.record?.id;

    const handleInvoice = async () => {
        setLoading(true);
        try {
            await axios.post(
                `update/loan/application/invoice-status/${applicationId}`,
                { agent_mail_address: LoanStateData?.record?.agent_mail_address }
            );
            toast.success("Invoice sent successfully to agent!");
        } catch (error) {
            // toast.error("Failed to send invoice!");
            console.error(error);
        } finally {
            setLoading(false);
            navigate(-1);
        }
    };

    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-hidden">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Dealer Generated Invoice</p>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className='min-[768px]:mx-[50px]'>
                <iframe src={`${API.BaseUrl}application/invoice/${applicationId}`} className='h-[900px]' id='pdf' title="PDF Viewer" width="100%" />
            </div>
            <div className="bg-white text-center p-[18px_25px]">
                <Row className="w-full h-full flex justify-end items-end">
                    <Col>
                        {LoanStateData?.record.invoice_status_code === 0 && (
                            <Button
                                onClick={handleInvoice}
                                type="primary"
                                loading={loading}
                                disabled={loading}
                            >
                                <SendOutlined style={{ fontSize: 17, marginRight: 4 }} />
                                Send Invoice
                            </Button>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
};
export default InvoiceGenerate;
